var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loggers',{attrs:{"loggers-service":_vm.service,"instance-count":_vm.application.instances.length},on:{"changeScope":_vm.changeScope}})}
var staticRenderFns = []

export { render, staticRenderFns }